import { buildCustomFieldDefaults } from "components/BaseForm";
import CONSTANTS from "constants/Constants";

export const FORM_MODES = {
  create: "create",
  edit: "edit",
};

export const BLANK_EMAIL = {
  email: "",
  is_primary: false,
  enabled: true,
  subscribed: true,
};

export const BLANK_PHONE = {
  number: "",
  ext: "",
  type: CONSTANTS.CONTACT_PHONE_TYPES.DEFAULT,
  is_primary: false,
  is_callable: true,
  enabled: true,
};

// The domain fields are read-only here: they only drive the MX warning icon.
const toFormEmail = email => ({
  id: email.id,
  email: email.email,
  is_primary: Boolean(email.is_primary),
  enabled: Boolean(email.enabled),
  subscribed: Boolean(email.subscribed),
  domain_status: email.domain_status ?? null,
  disabled_reason: email.disabled_reason ?? null,
});

const toFormPhone = phone => ({
  id: phone.id,
  number: phone.number,
  ext: phone.ext ?? "",
  type: phone.type,
  is_primary: Boolean(phone.is_primary),
  is_callable: Boolean(phone.is_callable),
  enabled: Boolean(phone.enabled),
});

// As in the legacy edit form, a contact without addresses or numbers opens
// with one empty row of each.
const fromRecord = record => ({
  full_name: record.full_name ?? "",
  preferred_name: record.preferred_name ?? "",
  title: record.title ?? "",
  entity_id: record.entity_id,
  department_id: record.department_id ?? null,
  email_addresses: record.email_addresses?.length
    ? record.email_addresses.map(toFormEmail)
    : [{ ...BLANK_EMAIL, is_primary: true }],
  phone_numbers: record.phone_numbers?.length
    ? record.phone_numbers.map(toFormPhone)
    : [{ ...BLANK_PHONE }],
  alternate_names: (record.alternate_names ?? []).map(({ name }) => name),
  tags: record.tags ?? [],
});

const fromPreset = preset => ({
  full_name: preset.fullName ?? "",
  preferred_name: "",
  title: "",
  entity_id: preset.entityId ?? null,
  department_id: null,
  email_addresses: [
    { ...BLANK_EMAIL, is_primary: true, email: preset.email ?? "" },
  ],
  phone_numbers: [
    preset.phone
      ? { ...BLANK_PHONE, is_primary: true, number: preset.phone }
      : { ...BLANK_PHONE },
  ],
  alternate_names: [],
  tags: [],
});

/** Initial form values for each mode. */
export const buildDefaultValues = ({
  mode,
  record,
  preset = {},
  customFieldConfigs,
}) =>
  mode === FORM_MODES.edit
    ? {
        ...fromRecord(record),
        custom_fields: buildCustomFieldDefaults(
          customFieldConfigs,
          record.custom_fields
        ),
      }
    : {
        ...fromPreset(preset),
        custom_fields: buildCustomFieldDefaults(customFieldConfigs, null),
      };
